import { useState } from "react";
import { BsList } from "react-icons/bs";
import { Route, Switch, useHistory, useLocation } from "react-router-dom";
import "../styles/section-chef.css";

import { Drawer } from "@mui/material";
import { AiFillCloseCircle } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";

import FoodHygieneCertificate from "../../pages/FoodHygieneCertificate";
import { POST_LOGOUT } from "../../store/action";
import { t } from "../../translations";
import { FEATURE_FLAGS } from "../constants/featureFlags";
import BankingDetailsPage from "../pages/banking-details";
import HelpCenter from "../pages/help-center";
import BasicInfo from "./basic_info";
import CookingDeliveryDay from "./cooking_delivery_day";
import SelectAddMenu from "./select_add_menu";
import SelectAddressNative from "./select_address_native";
import SelectBlog from "./select_blog";
import SelectCuisine from "./select_cuisine";
import SelectEditMenu from "./select_edit_menu";
import SelectGlocery from "./select_glocery";
import SelectHub from "./select_hub";
import SelectMenu from "./select_menu";
import SelectOrder from "./select_order";
import SelectProfil from "./select_profil";
import SelectWithdrawal from "./select_withdrawal";
import SubscriptionCancelledPage from "./SubscriptionCancelledPage";
import SubscriptionSuccessPage from "./SubscriptionSuccessPage";

const SectionChef = () => {
  const history = useHistory();
  const location = useLocation();
  const [open, setOpen] = useState(false);

  const zip = useSelector((state) => state.selectedZip);

  const lang = useSelector((state) => state.lang);
  const user = useSelector((state) => state.user);

  const [selectedCuisine, setSelectedCuisine] = useState([]);

  const [address, setAddress] = useState({
    province: user?.province,
    city: user?.city,
    zip: user?.zip,
    street: user?.street,
    line: user?.line,
    pickup_instruction: user?.pickup_instruction,
    lat: user?.position?.lat,
    lng: user?.position?.lng
  });

  const [profil, setProfil] = useState({
    preview: user?.preview,
    pic1: user?.pic1,
    pic2: user?.pic2,
    pic3: user?.pic3,
    max_dish: user?.max_dish,
    firstname: user?.firstname,
    lastname: user?.lastname,
    email: user?.email,
    number: user?.number,
    bio: user?.bio,
    notification: user?.notification,
    notification_cancel: user?.notification_cancel,
    order_timing: user?.order_timing,
    country: user?.country,
    geographical_tag: user?.geographical_tag
  });

  const dispatch = useDispatch();

  const LogOutUser = () => dispatch(post_logout());

  return (
    <div className="section-chef">
      <div className="section-chef-left-mobile">
        <div
          style={{
            display: "flex",
            alignItems: "center"
          }}
        ></div>
        <BsList
          size={50}
          color="#fff"
          onClick={() => {
            setOpen(true);
          }}
        />
      </div>
      <div className="section-chef-left">
        <div
          className="navbar-mobile"
          style={{
            padding: 5,
            width: "100%",
            height: "100%",
            backgroundColor: "#040404"
          }}
        >
          {[
            {
              text: t("navigation.dashboard", lang),
              value: "/home",
              action: () => {}
            },
            {
              text: t("navigation.my_profile", lang),
              value: "/profil",
              action: () => {}
            },
            {
              text: t("navigation.dishes", lang),
              value: "/menu",
              action: () => {}
            },
            {
              text: t("navigation.orders", lang),
              value: "/order",
              action: () => {}
            },
            {
              text: t("navigation.groceries", lang),
              value: "/glocery",
              action: () => {}
            },
            {
              text: t("navigation.withdrawals", lang),
              value: "/withdrawal",
              action: () => {}
            },
            {
              text: t("navigation.banking", lang),
              value: "/banking",
              action: () => {}
            },
            {
              text: t("navigation.my_blog", lang),
              value: "/blog",
              action: () => {},
              featureFlag: "blogEnabled"
            },
            {
              text: t("navigation.certificate", lang),
              value: "/certificate",
              action: () => {}
            }
          ]
            .filter(
              (item) => !item.featureFlag || FEATURE_FLAGS[item.featureFlag]
            )
            .map((item) => (
              <div
                className="section-chef-left-item"
                style={{
                  backgroundColor:
                    location.pathname === `/chef/iam-a-chef${item?.value}`
                      ? "#242424"
                      : "#000"
                }}
                onClick={() => {
                  item?.action();
                  return history.push("/chef/iam-a-chef" + item?.value);
                }}
              >
                {item?.text}
              </div>
            ))}
          <hr />
          {[
            {
              text: t("navigation.help_center", lang),
              value: "/help",
              action: () => {}
            },
            {
              text: t("navigation.go_back_home", lang),
              value: "/",
              action: () => {}
            },
            {
              text: t("navigation.sign_out", lang),
              out: true,
              value: "/",
              action: () => {
                LogOutUser();
              }
            }
          ].map((item) => (
            <div
              className="section-chef-left-item"
              style={{
                color:
                  item?.text === t("navigation.sign_out", lang)
                    ? "#ff114d"
                    : "#fff"
              }}
              onClick={() => {
                item?.action();
                if (item.value === "/") {
                  return history.push("/");
                }
                return history.push("/chef/iam-a-chef" + item?.value);
              }}
            >
              {item?.text}
            </div>
          ))}
        </div>
      </div>

      <div className="section-chef-right">
        <Switch>
          <Route path="/chef/iam-a-chef/home">
            {location.search?.includes("subscription=success") ? (
              <SubscriptionSuccessPage />
            ) : location.search?.includes("subscription=cancelled") ? (
              <SubscriptionCancelledPage />
            ) : (
              <BasicInfo />
            )}
          </Route>
          <Route path="/chef/iam-a-chef/cuisine">
            <SelectCuisine
              selectedCuisine={selectedCuisine}
              setSelectedCuisine={setSelectedCuisine}
              user={user}
              lang={lang}
            />
          </Route>
          <Route path="/chef/iam-a-chef/address">
            <SelectAddressNative
              address={address}
              setAddress={setAddress}
              user={user}
              lang={lang}
            />
          </Route>
          <Route path="/chef/iam-a-chef/profil">
            <SelectProfil
              user={user}
              lang={lang}
              profil={profil}
              setProfil={setProfil}
            />
          </Route>
          <Route path="/chef/iam-a-chef/cooking-delivery-day">
            <CookingDeliveryDay />
          </Route>
          <Route path="/chef/iam-a-chef/menu">
            <SelectMenu user={user} lang={lang} />
          </Route>
          <Route path="/chef/iam-a-chef/add-menu">
            <SelectAddMenu user={user} lang={lang} />
          </Route>
          <Route path="/chef/iam-a-chef/edit-menu">
            <SelectEditMenu user={user} lang={lang} />
          </Route>
          <Route path="/chef/iam-a-chef/order">
            <SelectOrder user={user} lang={lang} />
          </Route>
          <Route path="/chef/iam-a-chef/glocery">
            <SelectGlocery user={user} lang={lang} selectedZip={zip} />
          </Route>
          <Route path="/chef/iam-a-chef/withdrawal">
            <SelectWithdrawal user={user} lang={lang} selectedZip={zip} />
          </Route>
          <Route path="/chef/iam-a-chef/banking">
            <BankingDetailsPage />
          </Route>
          {FEATURE_FLAGS.blogEnabled && (
            <Route path="/chef/iam-a-chef/blog">
              <SelectBlog user={user} lang={lang} selectedZip={zip} />
            </Route>
          )}
          <Route path="/chef/iam-a-chef/hub">
            <SelectHub user={user} lang={lang} />
          </Route>
          <Route path="/chef/iam-a-chef/certificate">
            <FoodHygieneCertificate />
          </Route>
          <Route path="/chef/iam-a-chef/help">
            <HelpCenter />
          </Route>
          {/* Default route - redirect to home if no match */}
          <Route>
            <BasicInfo />
          </Route>
        </Switch>
      </div>
      <Drawer anchor={"right"} open={open} onClose={() => setOpen(false)}>
        <div
          className="navbar-mobile"
          style={{
            padding: 5,
            width: 300,
            height: "100%",
            backgroundColor: "#040404"
          }}
        >
          <span
            style={{
              color: "#fff",
              fontSize: 20,
              fontWeight: 600
            }}
            onClick={() => {
              setOpen(false);
            }}
          >
            <AiFillCloseCircle color={"#fff"} size={40} />
          </span>
          <hr />
          {[
            {
              text: t("navigation.dashboard", lang),
              value: "/home",
              action: () => {}
            },
            {
              text: t("navigation.my_profile", lang),
              value: "/profil",
              action: () => {}
            },
            {
              text: t("navigation.dishes", lang),
              value: "/menu",
              action: () => {}
            },
            {
              text: t("navigation.orders", lang),
              value: "/order",
              action: () => {}
            },
            {
              text: t("navigation.groceries", lang),
              value: "/glocery",
              action: () => {}
            },
            {
              text: t("navigation.withdrawals", lang),
              value: "/withdrawal",
              action: () => {}
            },
            {
              text: t("navigation.banking", lang),
              value: "/banking",
              action: () => {}
            },
            {
              text: t("navigation.my_blog", lang),
              value: "/blog",
              action: () => {},
              featureFlag: "blogEnabled"
            },
            {
              text: t("navigation.certificate", lang),
              value: "/certificate",
              action: () => {}
            }
          ]
            .filter(
              (item) => !item.featureFlag || FEATURE_FLAGS[item.featureFlag]
            )
            .map((item) => (
              <div
                className="section-chef-left-item"
                style={{
                  backgroundColor:
                    location.pathname === `/chef/iam-a-chef${item?.value}`
                      ? "#242424"
                      : "#000"
                }}
                onClick={() => {
                  item?.action();
                  return history.push("/chef/iam-a-chef" + item?.value);
                }}
              >
                {item?.text}
              </div>
            ))}
          <hr />
          {[
            {
              text: t("navigation.help_center", lang),
              value: "/help",
              action: () => {}
            },
            {
              text: t("navigation.go_back_home", lang),
              value: "/",
              action: () => {}
            },
            {
              text: t("navigation.sign_out", lang),
              out: true,
              value: "/",
              action: () => {
                LogOutUser();
              }
            }
          ].map((item) => (
            <div
              className="section-chef-left-item"
              style={{
                color:
                  item?.text === t("navigation.sign_out", lang)
                    ? "#ff114d"
                    : "#fff"
              }}
              onClick={() => {
                item?.action();
                if (item.value === "/") {
                  return history.push("/");
                }
                return history.push("/chef/iam-a-chef" + item?.value);
              }}
            >
              {item?.text}
            </div>
          ))}
        </div>
      </Drawer>
    </div>
  );
};

export default SectionChef;

const post_logout = () => ({
  type: POST_LOGOUT,
  data: null
});
